// Bugsnag client-side configuration
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
  apiKey: '87b1c44f8bcefb669bf90ed7223b9bac',
  appVersion: '0.1.0',
  releaseStage: process.env.NODE_ENV || 'development',
  enabledReleaseStages: ['staging', 'production'],
  plugins: [new BugsnagPluginReact()],
  maxBreadcrumbs: 10,

  onError: (event) => {
    if (event.breadcrumbs && event.breadcrumbs.length > 5) {
      event.breadcrumbs = event.breadcrumbs.slice(-5);
    }
    return true;
  },
});

export default Bugsnag;
